import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useId } from 'react';
import { SvgChevronDownSingle } from '../__generated__/icons/SvgChevronDownSingle.js';
import { Label } from '../label/Label.js';
import { InlineError } from '../user-feedback/InlineError.js';
import { InlineSuccess } from '../user-feedback/InlineSuccess.js';
import { mergeThemes } from '../utils/themes.js';
import { inlineMessageMargin, selectWrapper, errorChevron, successChevron, supportingTextMargin, select, errorInput, successInput } from './styles.js';
import { transformProviderTheme, themeSelect } from './theme.js';
import { descriptionId } from '../../foundations/accessibility/description-id.js';

const Select = ({
  id,
  label: labelText,
  optional = false,
  hideLabel = false,
  supporting,
  error,
  success,
  cssOverrides,
  children,
  theme,
  ...props
}) => {
  const defaultId = useId();
  const selectId = id ?? defaultId;
  const mergedTheme = (providerTheme) => mergeThemes(
    themeSelect,
    theme,
    providerTheme,
    transformProviderTheme
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Label,
      {
        text: labelText,
        optional: !!optional,
        supporting,
        hideLabel,
        htmlFor: selectId,
        theme,
        children: [
          error && /* @__PURE__ */ jsx("div", { css: inlineMessageMargin, children: /* @__PURE__ */ jsx(InlineError, { id: descriptionId(selectId), theme, children: error }) }),
          !error && success && /* @__PURE__ */ jsx("div", { css: inlineMessageMargin, children: /* @__PURE__ */ jsx(InlineSuccess, { id: descriptionId(selectId), theme, children: success }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        css: (theme2) => [
          selectWrapper(mergedTheme(theme2.select)),
          error ? errorChevron(mergedTheme(theme2.select)) : "",
          !error && success ? successChevron(mergedTheme(theme2.select)) : "",
          !error && !success ? supportingTextMargin : ""
        ],
        children: [
          /* @__PURE__ */ jsx(
            "select",
            {
              css: (theme2) => [
                select(mergedTheme(theme2.select)),
                error ? errorInput(mergedTheme(theme2.select)) : "",
                !error && success ? successInput(mergedTheme(theme2.select)) : "",
                cssOverrides
              ],
              "aria-required": !optional,
              "aria-invalid": !!error,
              "aria-describedby": error ?? success ? descriptionId(selectId) : "",
              id: selectId,
              ...props,
              children
            }
          ),
          /* @__PURE__ */ jsx(SvgChevronDownSingle, { theme: { fill: theme?.iconFill } })
        ]
      }
    )
  ] });
};

export { Select };
